import React, { Dispatch, SetStateAction } from 'react';
import {
  View, Text, StyleSheet, Image,
} from 'react-native';
import * as ImagePicker from 'expo-image-picker';
import CustomTextField from '../../../../../../../components/CustomTextField';
import Button from '../../../../../../../components/Button';
import { AssetInstance, MeterLabel, SensorLabel } from '../../../../../../../constants/Types';
import Colors from '../../../../../../../constants/Colors';
import AssetLabelSelector from '../../../../../../../components/AssetManagement/AddAssetModal/components/AssetLabelSelector';
import { logEvent } from '../../../../../../../components/LogEvent';

interface EssentialInfoProps {
  image: string,
  setImage: Dispatch<SetStateAction<string>>,
  name: string,
  setName: Dispatch<SetStateAction<string>>,
  asset: AssetInstance,
  description: string,
  setDescription: Dispatch<SetStateAction<string>>,
  model: string,
  setModel: Dispatch<SetStateAction<string>>,
  serial: string,
  setSerial: Dispatch<SetStateAction<string>>,
  manufacturer: string,
  setManufacturer: Dispatch<SetStateAction<string>>,
  labels: SensorLabel[] | MeterLabel[],
  setLabels: Dispatch<SetStateAction<SensorLabel[] | MeterLabel[]>>,
  labelsDropdownShown: boolean,
  setLabelsDropdownShown: Dispatch<SetStateAction<boolean>>,
  labelsInvalid: boolean,
  handleImage: Function,
}

const EssentialInfo = ({
  image, setImage, name, setName, asset, description, setDescription, model, setModel, serial,
  setSerial, manufacturer, setManufacturer, labels, setLabels, labelsDropdownShown, labelsInvalid,
  setLabelsDropdownShown, handleImage,
}: EssentialInfoProps) => {
  const pickImage = async () => {
    logEvent('EditAssetModal', 'Upload');
    // No permissions request is necessary for launching the image library
    const result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      quality: 0.2,
      base64: true,
    });

    if (result.assets[0]?.uri) handleImage(result.assets[0]?.uri);
  };

  return <>
    <View style={styles.imageContainer}>
      <Image
        style={styles.image}
        source={{ uri: image }}
      />
      <View>
        <Text style={styles.imageLabel}>{'Image'}</Text>
        <Button
          title={image ? 'Delete' : 'Upload'}
          style={styles.deleteButton}
          onPress={() => {
            if (image) setImage(null);
            else pickImage();
          }}
        />
      </View>
    </View>
    <CustomTextField
      required
      title='Name'
      value={name}
      updateValue={setName}
    />
    <AssetLabelSelector
      {...{
        labels, setLabels, labelsDropdownShown, setLabelsDropdownShown,
      }}
      templateType={asset.type}
      invalid={labelsInvalid}
    />
    <CustomTextField
      required
      editable={false}
      title='ID'
      value={asset.id}
    />
    <CustomTextField
      title='Description'
      value={description}
      updateValue={setDescription}
    />
    <CustomTextField
      title='Model'
      value={model}
      updateValue={setModel}
    />
    <CustomTextField
      title='Serial'
      value={serial}
      updateValue={setSerial}
    />
    <CustomTextField
      title='Manufacturer'
      value={manufacturer}
      updateValue={setManufacturer}
    />
  </>;
};

const styles = StyleSheet.create({
  imageContainer: {
    marginTop: 24,
    flexDirection: 'row',
    alignItems: 'center',
    padding: 16,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: Colors.light.hereworksBlue100,
  },
  image: {
    width: 120,
    height: 120,
    marginEnd: 32,
    backgroundColor: Colors.light.hereworksPrimaryGrey200,
  },
  imageLabel: {
    fontSize: 16,
    lineHeight: 24,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlack400,
  },
  deleteButton: {
    marginTop: 16,
    height: 32,
  },
});

export default EssentialInfo;
